<div class="row">
    <div class="col-12">        
        <div class="table-responsive">
            <table class="table table-bordered">                      
                <thead>
                    <tr>
                        <th class="col-options"></th>
                        <th class="col-representante-vinculado">Representante</th>
                    </tr>
                </thead>
                <tbody *ngFor="let entity of entities; let i = index">
                    <tr>
                        <td class="col-options">
                            <a (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="col-representante-vinculado">
                            <sgt-typeahead-representante [(ngModel)]="entity.representanteVinculado" name="representanteVinculado_{{i}}" id="representanteVinculado_{{i}}"
                                #representanteVinculado="ngModel" [ngControl]="representanteVinculado" [autofocus]="true" [dropup]="i >= 4"
                                (typeaheadChange)="onChangeRepresentanteVinculado(entity, $event)">
                            </sgt-typeahead-representante>                                                                         
                        </td>                                                               
                    </tr>          
                </tbody>
                <tbody *ngIf="entities.length === 0" class="no-record">
                    <tr>
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                        </td>
                    </tr>
                </tbody>
                <tfoot class="table-footer">
                    <tr>
                        <td colspan="2">
                            <button type="button" class="btn btn-primary" (click)="insert()">
                                <i class="fas fa-link"></i> Vincular Representante
                            </button>                                          
                        </td>                               
                    </tr>
                </tfoot>        
            </table>
        </div>
    </div>
</div>